module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('placeholder.selectComponent')
    },
    model: {
      value: (_vm.selectedComponent),
      callback: function($$v) {
        _vm.selectedComponent = $$v
      },
      expression: "selectedComponent"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": _vm.$t(item.label),
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": !_vm.selectedComponent
    },
    on: {
      "click": _vm.addDashoardItem
    }
  }, [_vm._v("Add new")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.frozen = !_vm.frozen
      }
    }
  }, [_vm._v("Lock")]), _vm._v(" "), _c('grid-layout', {
    attrs: {
      "layout": _vm.layout,
      "col-num": 4,
      "row-height": 1,
      "is-draggable": !_vm.frozen,
      "is-resizable": !_vm.frozen,
      "vertical-compact": false,
      "margin": [10, 10],
      "use-css-transforms": true
    }
  }, _vm._l((_vm.layout), function(item) {
    return _c('grid-item', {
      attrs: {
        "x": item.x,
        "y": item.y,
        "w": item.w,
        "h": item.h,
        "i": item.i
      }
    }, [(item.component) ? _c('div', {
      staticClass: "card card--small"
    }, [(item.component.title || item.component.configName) ? _c('div', {
      staticClass: "header"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.frozen),
        expression: "!frozen"
      }],
      staticClass: "config-icon",
      on: {
        "click": function($event) {
          return _vm.removeComponent(item.i)
        }
      }
    }, [_c('fa-icon', {
      attrs: {
        "icon": "trash-o"
      }
    })], 1), _vm._v(" "), (item.component.configName) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.frozen),
        expression: "!frozen"
      }],
      staticClass: "config-icon",
      on: {
        "click": function($event) {
          item.component.isConfiguring = !item.component.isConfiguring
        }
      }
    }, [_c('fa-icon', {
      attrs: {
        "icon": item.component.isConfiguring ? 'floppy-o' : 'cog'
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('h4', {
      staticClass: "title"
    }, [_c('live-edit', {
      attrs: {
        "editable": !_vm.frozen
      },
      model: {
        value: (item.component.title),
        callback: function($$v) {
          _vm.$set(item.component, "title", $$v)
        },
        expression: "item.component.title"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (item.component.isConfiguring) ? _c('div', {
      staticClass: "config-box"
    }, [_c(item.component.configName, _vm._b({
      tag: "component",
      on: {
        "propertiesChanged": function($event) {
          return _vm.updateComponent(item.component, $event)
        }
      }
    }, 'component', item.component.properties, false))], 1) : _c('div', {
      staticClass: "body",
      class: {
        'padded-body': item.component.needsPadding
      }
    }, [_c(item.component.name, _vm._b({
      ref: "item.component.ref",
      refInFor: true,
      tag: "component"
    }, 'component', item.component.properties, false))], 1)]) : _vm._e()])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e16b6992!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 1036
// module chunks = 2